const types = {
    LISTEN_LAST_IMPORT: 'imports/LISTEN_LAST_IMPORT',
    UNLISTEN_LAST_IMPORT: 'imports/UNLISTEN_LAST_IMPORT',
    LISTEN_LOGS: 'imports/LISTEN_LOGS',
    UNLISTEN_LOGS: 'imports/UNLISTEN_LOGS',
};

const importTypes = {
    BEGIN_IMPORT: 'imports/BEGIN_IMPORT',
    SET_IN_PROCESS: 'imports/SET_IN_PROCESS',
};

export default {
    ...types,
    ...importTypes,
};
